import { render } from "./AdminManageGroomers.vue?vue&type=template&id=9a4278be&scoped=true"
import script from "./AdminManageGroomers.vue?vue&type=script&lang=js"
export * from "./AdminManageGroomers.vue?vue&type=script&lang=js"

import "./AdminManageGroomers.vue?vue&type=style&index=0&id=9a4278be&scoped=true&lang=css"

import exportComponent from "E:\\coding\\pharaoh_frog_barber\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a4278be"]])

export default __exports__